/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    message_id: string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    referral_id: string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    message_type: MessageMessageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    sender_user_id: string | null;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    sender_facility_id: string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    receiver_facility_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    system_event_type: MessageSystemEventTypeEnum | null;
    /**
     * 
     * @type {object}
     * @memberof Message
     */
    system_event_data: object | null;
    /**
     * 
     * @type {Date}
     * @memberof Message
     */
    created_at: Date;
}


/**
 * @export
 */
export const MessageMessageTypeEnum = {
    User: 'user',
    System: 'system'
} as const;
export type MessageMessageTypeEnum = typeof MessageMessageTypeEnum[keyof typeof MessageMessageTypeEnum];

/**
 * @export
 */
export const MessageSystemEventTypeEnum = {
    StatusChange: 'status_change',
    RecipientStatusChange: 'recipient_status_change',
    DocumentAdded: 'document_added',
    DateChanged: 'date_changed'
} as const;
export type MessageSystemEventTypeEnum = typeof MessageSystemEventTypeEnum[keyof typeof MessageSystemEventTypeEnum];


/**
 * Check if a given object implements the Message interface.
 */
export function instanceOfMessage(value: object): value is Message {
    if (!('message_id' in value) || value['message_id'] === undefined) return false;
    if (!('referral_id' in value) || value['referral_id'] === undefined) return false;
    if (!('message_type' in value) || value['message_type'] === undefined) return false;
    if (!('sender_user_id' in value) || value['sender_user_id'] === undefined) return false;
    if (!('sender_facility_id' in value) || value['sender_facility_id'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('system_event_type' in value) || value['system_event_type'] === undefined) return false;
    if (!('system_event_data' in value) || value['system_event_data'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    return true;
}

export function MessageFromJSON(json: any): Message {
    return MessageFromJSONTyped(json, false);
}

export function MessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Message {
    if (json == null) {
        return json;
    }
    return {
        
        'message_id': json['message_id'],
        'referral_id': json['referral_id'],
        'message_type': json['message_type'],
        'sender_user_id': json['sender_user_id'],
        'sender_facility_id': json['sender_facility_id'],
        'receiver_facility_id': json['receiver_facility_id'] == null ? undefined : json['receiver_facility_id'],
        'content': json['content'],
        'system_event_type': json['system_event_type'],
        'system_event_data': json['system_event_data'],
        'created_at': (new Date(json['created_at'])),
    };
}

export function MessageToJSON(json: any): Message {
    return MessageToJSONTyped(json, false);
}

export function MessageToJSONTyped(value?: Message | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message_id': value['message_id'],
        'referral_id': value['referral_id'],
        'message_type': value['message_type'],
        'sender_user_id': value['sender_user_id'],
        'sender_facility_id': value['sender_facility_id'],
        'receiver_facility_id': value['receiver_facility_id'],
        'content': value['content'],
        'system_event_type': value['system_event_type'],
        'system_event_data': value['system_event_data'],
        'created_at': ((value['created_at']).toISOString()),
    };
}

